import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";

const AddFAQ = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row } = location.state || {};
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { 
        "Content-Type": "application/json",
        "auth-token": authToken, 
        "authorization": accessToken 
    };
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    question: "",
    answer: "",
    status: "Active"
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);

  useEffect(() => {
    if (id && row) {
      setFormData({
        question: row?.question || "",
        answer: row?.answer || "",
        status: row?.status || "Active"
      });
    }
  }, [id, row]);

  const validate = () => {
    const newErrors = {};

    if (!formData.question?.trim()) {
      newErrors.question = "Question is required.";
    }

    if (!formData.answer?.trim()) {
      newErrors.answer = "Answer is required.";
    }

    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    try {
      // Create FormData object (matches your backend expectation)
      const formDataToSend = new FormData();

      // Append all fields
      formDataToSend.append("question", formData.question);
      formDataToSend.append("answer", formData.answer);
      formDataToSend.append("status", formData.status ?? "Active");

      // Add ID for update
      if (id) {
        formDataToSend.append("id", id);
      }

     

      let response;

      if (id) {
        // Update existing FAQ
        response = await APIServices.post(
          "/admin/faq/update_faq",
          formDataToSend,
          headers
        );
      } else {
        // Add new FAQ
        response = await APIServices.post(
          "/admin/faq/add_faq",
          formDataToSend,
          headers
        );
      }

      // Check response
      if (response?.data?.status === true) {
        showToast(
          response?.data?.message || (id ? "FAQ updated successfully" : "FAQ added successfully"),
          "success"
        );
        setTimeout(() => {
          navigate("/admin/faq");
        }, 2000);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        showToast(
          response?.data?.message || "Something went wrong.",
          "error"
        );
      }
    } catch (error) {
      console.error("API call error:", error);
      showToast(
        error.response?.data?.message || "An unexpected error occurred",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="add_faq_sec">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">
            {id ? "Edit FAQ" : "Add FAQ"}
          </h1>
        </div>

        <Card className="add_faq_form">
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Question <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="question"
                      placeholder="Enter your question"
                      value={formData.question}
                      onChange={handleChange}
                      isInvalid={!!errors.question}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.question}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2">
                      Answer <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      style={{ height: '150px' }}
                      rows={8}
                      name="answer"
                      placeholder="Enter your answer"
                      value={formData.answer}
                      onChange={handleChange}
                      isInvalid={!!errors.answer}
                      disabled={loading}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.answer}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>

              </Row>

              <div className="text-center mt-4">

                <Button
                  variant="primary"
                  className="me-2"
                  type="submit"
                  disabled={loading}
                >
                  {loading ? "Processing..." : (id ? "Update" : "Add")}
                </Button>
                <Button
                  variant="secondary"
                  className="me-2"
                  onClick={() => navigate("/admin/faq")}
                  disabled={loading}
                >
                  Cancel
                </Button>

              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>

      <ToastContainer />
    </>
  );
};

export default AddFAQ;